<template>
  <v-dialog max-width="700" v-model="isSummaryRegenerationDialog" @click:outside="close" @keydown.esc="close">
    <v-card class="px-3 py-4" color="#21343b" width="auto" elevation="0">
      <v-row no-gutters align="center" justify="center">
        <v-col cols="12" class="title">{{ $t('chooseTemplateTitle') }}</v-col>
        <v-col cols="12" class="subTitle">
          {{ $t('chooseTemplateSubTitle') }}
        </v-col>
      </v-row>
      <v-row no-gutters align="center" justify="center" class="mt-4">
        <v-col cols="12">
          <v-btn-toggle v-model="toggle_template" class="btn-toggle" dark mandatory>
            <v-btn>
              {{ $t('templateBtnCustom') }}
            </v-btn>
            <v-btn>
              {{ $t('templateBtnNone') }}
            </v-btn>
            <v-btn>
              {{ $t('templateBtnMeetingSummary') }}
            </v-btn>
            <v-btn>
              {{ $t('templateBtnProjectUpdate') }}
            </v-btn>
            <v-btn>
              {{ $t('templateBtnBugreport') }}
            </v-btn>
            <v-btn>
              {{ $t('templateBtnProductdemo') }}
            </v-btn>
          </v-btn-toggle>
        </v-col>
      </v-row>
      <v-row v-if="toggle_template !== 1" no-gutters align="center" justify="center" class="container-topics mt-4">
        <v-combobox
          v-model="selectedTopic"
          :filter="filter"
          :items="topics"
          :hide-no-data="!search"
          :search-input.sync="search"
          hide-selected
          label="Enter the topics you'd like to include here"
          solo
          multiple
          hide-details="auto"
          chips
          clearable
          background-color="#1a272e"
          class="container-combobox"
          style="border-radius: 5px"
          :error="comboboxError.status"
          :error-messages="comboboxError.message"
          dark
        >
          <template v-slot:no-data>
            <v-list-item dark style="color: #aaa">
              <v-list-item-content>
                <v-list-item-title>
                  No results matching "
                  <strong>{{ search }}</strong>
                  ".
                </v-list-item-title>
                <v-list-item-title>
                  Press
                  <kbd>enter</kbd>
                  to create a new topic.
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>

          <template v-slot:selection="{ attrs, item, parent, selected }">
            <v-chip v-if="item === String(item)" v-bind="attrs" :input-value="selected" label dark>
              <span class="pr-2">
                {{ item }}
              </span>
              <v-icon small @click="parent.selectItem(item)">$delete</v-icon>
            </v-chip>
          </template>

          <template v-slot:item="{ index, item }">
            <v-chip :key="item.index" dark label>
              {{ item }}
            </v-chip>
          </template>
        </v-combobox>
      </v-row>
      <v-row no-gutters align="center" justify="space-between" class="mt-5">
        <v-col cols="auto" class="wrap-btn-regeneration" align="start" v-if="btnSelectLanguage">
          <select-language
            :plain="false"
            :autoDetect="false"
            :isClOrganizer="null"
            btnName="Done"
            btnIcon=""
            :basicBtnName="language ? language : 'Select Language'"
            basicBtnColor="#1a272e"
            basicBtnFontColor="#ddd"
            :basicBtnIcon="language ? '' : 'translate'"
            basicBtnIconColor=""
            subTitle="Choose the target language into which you want to translate the summary."
            @language="submitLanguage"
          ></select-language>
        </v-col>
        <v-col :cols="!btnSelectLanguage ? '12' : 'auto'" class="wrap-btn-regeneration" align="end">
          <v-btn :loading="isRegenerateLoading" dark class="btn-regeneration" elevation="0" @click="submitRegeneration">
            <span class="material-icons-round mr-1" translate="no" style="color: #ffc107">auto_awesome</span>
            {{ btnName ? btnName : $t('regenerate') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
// import { setRegenerateSummary } from '@/services/clipApi'
import { mapGetters, mapActions } from 'vuex'
import SelectLanguage from '@/views/modal/SelectLanguage'

export default {
  name: 'SummaryRegeneration',
  components: { SelectLanguage },
  props: { isSummaryRegenerationDialog: Boolean, btnSelectLanguage: Boolean, btnName: String },
  data() {
    return {
      toggle_template: 0, // custom0 none1 MeetingSummary2 ProjectUpdate3 BugReport4 ProductDemo5
      selectedTopic: [], // 선택된 topic
      topics: [{ header: 'Popular topics' }, 'Updates', 'Action items', 'Talking Points', 'Due Date', 'Priority'], // 추천 topic
      topics1: ['Talking Points', 'Updates', 'Key decisions', 'Action items'], // meeting summary topic
      topics2: ['Key updates', 'Next steps', 'Obstacles', 'Roadblocks and risks', 'Deadlines', 'Comments'], // project update topic
      topics3: ['Steps to reproduce', 'Actual result', 'Expected Result', 'Environment', 'Priority'], // bug report topic
      topics4: ['Product overview', 'Demo', 'Comments'], // product demo topic
      search: null,
      comboboxError: {
        status: false,
        message: null,
      },
      prevTemplate: null,
      currTemplate: null,
      isRegenerateLoading: false,
      language: null,
    }
  },
  methods: {
    ...mapActions(['setSummaryInfo', 'setRegenerateSummary']),
    async submitRegeneration() {
      if (!this.btnName) {
        try {
          this.isRegenerateLoading = true

          // 기존 Summary 데이터 삭제
          this.$store.dispatch('setSummarySegments', null)
          this.totalSectionList[this.sectionIndex].clipList[this.clipIndex]['summaryStatus'] = 0
          this.currentClip['summaryStatus'] = 0
          this.$store.dispatch('setTotalSectionList', this.totalSectionList)
          this.$store.dispatch('setCurrentClip', this.currentClip)

          this.setRegenerateSummary({
            clipId: this.currentClip['clipId'],
            type: 'transcript',
            smId: this.summaryInfo['smId'],
            template: this.txtTemplate,
            customTopics: this.txtTemplate && this.txtTemplate !== 'none' ? this.selectedTopic : null,
            smLanguage: this.language,
          })
        } catch (error) {
          console.log('regenerate error : ', error)
        } finally {
          this.isRegenerateLoading = false
        }
      }

      this.$emit('close', 'SummaryRegeneration')
      this.$emit('submitTemplate', this.txtTemplate) // 선택한 템플릿 전달
      if (this.toggle_template !== 1) {
        this.$emit('submitTopic', this.selectedTopic) // custom일 경우 선택한 토픽 전달
      }
      this.$emit('language', this.language)
    },
    filter(item, queryText, itemText) {
      if (item.header) return false

      const hasValue = (val) => (val != null ? val : '')

      const text = hasValue(itemText)
      const query = hasValue(queryText)

      return text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
    },
    close() {
      this.$emit('close', 'SummaryRegeneration')
    },
    submitLanguage(language) {
      this.language = language ? language['label'] : null
    },
  },
  computed: {
    ...mapGetters(['currentClip', 'summaryInfo', 'totalSectionList', 'sectionIndex', 'clipIndex', 'currentClip']),
    txtTemplate() {
      let template

      switch (this.toggle_template) {
        case 0:
          template = 'Custom'
          break
        case 1:
          template = 'None'
          break
        case 2:
          template = 'Meeting Summary'
          break
        case 3:
          template = 'Project Update'
          break
        case 4:
          template = 'Bug Report'
          break
        case 5:
          template = 'Product Demo'
          break
        default:
          template = 'None'
          break
      }
      return template
    },
  },
  watch: {
    toggle_template(val, prev) {
      this.prevTemplate = prev
      this.currTemplate = val
      switch (val) {
        case 0:
          this.selectedTopic = []
          break
        case 1:
          this.selectedTopic = []
          break
        case 2:
          this.selectedTopic = this.topics1
          break
        case 3:
          this.selectedTopic = this.topics2
          break
        case 4:
          this.selectedTopic = this.topics3
          break
        case 5:
          this.selectedTopic = this.topics4
          break
        default:
          this.selectedTopic = []
          break
      }
    },
    selectedTopic(val, prev) {
      // 이전 템플릿의 토픽을 받아오는 현상 방지
      if (this.prevTemplate !== this.currTemplate) {
        this.prevTemplate = this.currTemplate
        return
      }
      if (val.length === prev.length) return

      for (let i = 0; i < val.length; i++) {
        // 콤마가 들어간 요소가 있으면
        if (val[i].indexOf(',') > -1) {
          // 일단 콤마를 기준으로 나눠줌
          for (let j = 0; j < val[i].split(',').length; j++) {
            // 문자열이 있으면 양 옆의 공백 제거 후 넣기
            if (val[i].split(',')[j]) val.push(val[i].split(',')[j].trim())
          }
          // 원래 요소는 제거
          val.splice(i, 1)
        }
      }
      this.selectedTopic = val.map((v) => {
        this.topics.push(v)
        return v
      })
    },
  },
}
</script>

<style scoped>
.v-dialog__content >>> .v-dialog {
  border-radius: 5px;
  padding: 5px 10px;
  overflow: hidden;
  background-color: #21343b;
}
.title {
  color: #fff;
}
.subTitle {
  font-size: 14px;
  color: #96a7af;
}
.btn-toggle {
  display: block;
  background: transparent !important;
}
.btn-toggle >>> button {
  height: 36px !important;
  margin: 4px 8px 4px 0;
  border-radius: 5px !important;
  background-color: #1a272e !important;
  font-size: 14px !important;
  font-weight: 500 !important;
}
.btn-toggle >>> span {
  font-size: 14px !important;
  font-weight: 500 !important;
}
.btn-toggle >>> button.v-item--active {
  box-shadow: 0 0 0 1px #27cd8b;
  color: #27cd8b;
  background-color: #1a272e !important;
}
.btn-toggle >>> button.v-item--active::before {
  opacity: 0;
}
.container-topics >>> input {
  padding-top: 0px;
  font-weight: 500;
  font-size: 14px !important;
}
.container-topics >>> .v-input__slot {
  flex-direction: row-reverse;
  padding: 12px !important;
}
.v-list {
  width: 100%;
  background-color: #1a272e;
}
.container-topics >>> .v-text-field input {
  padding: 0 !important;
}
.container-topics >>> .v-text-field input::placeholder {
  color: red !important;
}
.v-chip {
  margin-top: 6px;
  border-radius: 12px !important;
  background-color: #43535e !important;
}
.container-topics >>> div[role='combobox'] {
  box-shadow: none !important;
}
.container-topics >>> .v-select__selections {
  max-height: 130px;
  overflow-y: auto;
}
.container-combobox >>> .v-input__control {
  flex-direction: column-reverse;
}
.v-list >>> .v-subheader {
  font-size: 15px;
  font-weight: 600;
  color: #96a7af;
  justify-content: center;
  height: 36px;
}
kbd {
  background: #ddd !important;
  color: #1a272e !important;
  padding: 0.1em 0.4em !important;
}
button.btn-regeneration {
  background-color: rgb(40, 144, 103) !important;
  border-radius: 3px;
}
button.btn-regeneration >>> span {
  font-size: 14px;
  font-weight: 500;
}
</style>
